import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { FullScreenModalContainer } from '../../components/fullScreenModalContainer';
import { RefreshButton } from '../../components/refreshButton';
import { setReverifyPage } from '../../redux/actions/reverifyActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { REVERIFY_PAGE_BUTTONS_CONTAINER_CSS, REVERIFY_PAGE_EMAIL_CSS } from './reverifyPageConstants';
export const ReverifyCurrentEmailVerificationSentPage = () => {
    const dispatch = useAppDispatch();
    const currentEmail = useAppSelector((state) => state.reverify.currentEmail);
    const onClickCancel = useCallback(() => {
        dispatch(setReverifyPage('ask'));
    }, [dispatch]);
    return (_jsxs(FullScreenModalContainer, { title: 'Verify Email Account', children: [_jsxs("div", { children: ["A verification link has been emailed to", ' ', currentEmail ? _jsx("span", { css: REVERIFY_PAGE_EMAIL_CSS, children: currentEmail }) : 'you', "."] }), _jsx("div", { children: "Click the link in your email, then log in again. Thanks!" }), _jsxs("div", { css: REVERIFY_PAGE_BUTTONS_CONTAINER_CSS, children: [_jsx(RefreshButton, { label: 'Login', type: 'labeled', color: 'primary' }), _jsx(Button, { onClick: onClickCancel, variant: 'outlined', children: "Cancel" })] })] }));
};
